import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, inject, signal } from '@angular/core';
import { ValueFirstOnboardingService } from '../../services/value-first-onboarding.service';

@Component({
  selector: 'vf-code-step',
  templateUrl: './code-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VfCodeStep {
  readonly onboarding = inject(ValueFirstOnboardingService);
  readonly code = signal('');
  readonly boxes = [0, 1, 2, 3, 4, 5];

  @ViewChild('codeInput') codeInput?: ElementRef<HTMLInputElement>;

  digit(index: number): string {
    return this.code().charAt(index);
  }

  boxClass(index: number): string {
    const active = this.code().length === index || (this.code().length === 6 && index === 5);
    const filled = index < this.code().length;
    if (active || filled) {
      return 'border-primary' + (active ? ' ring-2 ring-primary/20' : '');
    }
    return 'border-border';
  }

  onCode(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '').slice(0, 6);
    input.value = digits;
    this.code.set(digits);
    this.onboarding.clearError();
    if (digits.length === 6) {
      void this.onboarding.verifyCode(digits);
    }
  }

  resend(): void {
    void this.onboarding.sendCode('', true);
  }

  changeEmail(): void {
    this.onboarding.goBack();
  }
}
